var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-main" },
    [_vm._m(0), _c("safe-area-bottom")],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", [
        _vm._v(
          " 为保障APP相关功能的实现与应用的安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。我们对接入的相关第三方SDK在目录中列明： "
        ),
      ]),
      _c("h2", [_vm._v("Android")]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("神策SDK")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备属性信息（Andriod ID/OAID/IDFA/IDFV/UUID）、位置信息、网络信息、设备硬件信息、操作系统信息、应用信息、手机加速度传感器用来获取手机屏幕方向数据 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：数据统计与分析"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://www.sensorsdata.cn" },
            },
            [_vm._v("https://www.sensorsdata.cn/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("QQ")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：操作系统信息、设备型号信息、剪切板、相册、内存卡权限、应用列表信息 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户分享至第三方应用、第三方支付"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://open.tencent.com/" },
            },
            [_vm._v("https://open.tencent.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("微信/腾讯开放平台"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("收集的数据：图片或内容、微信头像、昵称信息、支付信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户分享至第三方应用、第三方支付"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://open.weixin.qq.com/" },
            },
            [_vm._v("https://open.weixin.qq.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("微博/新浪")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备型号、设备标识符（如IMEI/ AndroidID/ IDFA/ OPENUDID/ GUID/ OAID）、设备MAC地址、电信运营商等软硬件特征信息 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户分享至新浪微博应用"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "https://open.weibo.com/" } },
            [_vm._v("https://open.weibo.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("Alipay（支付宝）"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户在应用内使用支付宝"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://open.alipay.com/" },
            },
            [_vm._v("https://open.alipay.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("华为push")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：应用信息、设备信息（AAID、设备标识符、设备硬件信息、系统基本信息、系统设置） "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [_vm._v("使用目的：推送消息")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://developer.huawei.com/" },
            },
            [_vm._v("https://developer.huawei.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("小米 push/小米推送"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备标识符（如Android ID、OAID）、应用信息、设备信息、网络信息（本地处理） "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [_vm._v("使用目的：推送消息")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "https://dev.mi.com/" } },
            [_vm._v("https://dev.mi.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("Vivo push")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备标识信息、应用软件信息、设备制造商、网络相关信息、设备类型 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [_vm._v("使用目的：推送消息")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://dev.vivo.com.cn/" },
            },
            [_vm._v("https://dev.vivo.com.cn/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("oppo push/oppo 推送"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备相关信息、应用信息、消息发送结果、通知栏状态、锁屏状态 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [_vm._v("使用目的：推送消息")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "https://push.oppo.com/" } },
            [_vm._v("https://push.oppo.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("中国移动 一键登录"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：网络类型、网络地址（ip地址）、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户一键登录APP"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://open.home.10086.cn/" },
            },
            [_vm._v("https://open.home.10086.cn/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("阿里云文件上传服务(oss)"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：系统版本、mac地址、IP、MAC、App版本信息、设备型号、ip地址、网络信息、网络连接 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：上传用户文件(头像、录音、日志等)"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://cn.aliyun.com/product/oss" },
            },
            [_vm._v("https://cn.aliyun.com/product/oss")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("Sentry")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：系统版本,mac地址,App版本信息,设备型号,ip地址,网络信息,Android_ID,传感器信息。 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户查询操作问题，不向第三方传输数据。"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "https://sentry.io/" } },
            [_vm._v("https://sentry.io/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("华为分析SDK（Android版）"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("第三方名称：华为软件技术有限公司"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集个人信息类型：应用信息、设备信息、位置信息、网络信息、设备信息（OAID）、应用设置信息 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：为开发者应用提供数据采集、分析服务"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/android-sdk-data-security-0000001050745153",
              },
            },
            [
              _vm._v(
                "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/android-sdk-data-security-0000001050745153"
              ),
            ]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("移动安全联盟 OAID SDK"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：收集的数据：设备制造商、设备型号、设备品牌、网络运营商名称 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 使用目的：获取 oaid（设备制造商、设备型号、设备品牌，用于判断终端调用接口；设备网络运营商名称，用于判断虚拟机环境；APP 包名，用于校验签名） "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "http://www.msa-alliance.cn/col.jsp?id=122" },
            },
            [_vm._v("http://www.msa-alliance.cn/col.jsp?id=122")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("钉钉分享")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("收集的数据：分享的图片或内容"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户分享至第三方应用"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html",
              },
            },
            [
              _vm._v(
                "https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html"
              ),
            ]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("腾讯 X5 浏览器")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备信息、Wi-Fi状态和参数、位置信息、附近Wi-Fi、CellID、设备信息、标识符（OAID等）、应用信息、广告数据 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            "使用目的：用于应用内识别扫描的二维码、方便用户快速找到目标项目"
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://x5.tencent.com/tbs/index.html" },
            },
            [_vm._v("https://x5.tencent.com/tbs/index.html")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("极光推送（com.aurora，com.engagelab）"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备标识符、设备硬件信息、操作系统信息、网络信息、推送信息日志 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：为 APP 用户提供信息推送服务"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://www.jiguang.cn/push" },
            },
            [_vm._v("https://www.jiguang.cn/push")]
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 隐私政策链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://www.jiguang.cn/license/privacy" },
            },
            [_vm._v("https://www.jiguang.cn/license/privacy")]
          ),
        ]),
      ]),
      _c("h2", [_vm._v("iOS")]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("Alipay（支付宝）"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户在应用内使用支付宝"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://open.alipay.com/" },
            },
            [_vm._v("https://open.alipay.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("神策SDK")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备属性信息（OAID/IDFA/IDFV/UUID）、位置信息、网络信息、设备硬件信息、操作系统信息、应用信息、手机加速度传感器用来获取手机屏幕方向数据 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：数据统计与分析"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://www.sensorsdata.cn" },
            },
            [_vm._v("https://www.sensorsdata.cn/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("QQ分享")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：操作系统信息、设备型号信息、剪切板、相册、内存卡权限、应用列表信息 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户分享至第三方应用"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://connect.qq.com/index.html" },
            },
            [_vm._v("https://connect.qq.com/index.html")]
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("微信分享/腾讯开放平台"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("收集的数据：图片或内容、微信头像、昵称信息、支付信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户分享至第三方应用"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://open.weixin.qq.com/" },
            },
            [_vm._v("https://open.weixin.qq.com/")]
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("微博分享")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：设备型号、设备标识符（如IMEI/ AndroidID/ IDFA/ OPENUDID/ GUID/ OAID）、设备MAC地址、电信运营商等软硬件特征信息 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户分享至新浪微博"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "https://open.weibo.com/" } },
            [_vm._v("https://open.weibo.com/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("中国移动 一键登录"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：网络类型、网络地址（ip地址）、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户一键登录APP"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://open.home.10086.cn/" },
            },
            [_vm._v("https://open.home.10086.cn/")]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [_vm._v("钉钉分享")]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("收集的数据：分享的图片或内容"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("使用目的：帮助用户分享至第三方应用"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html",
              },
            },
            [
              _vm._v(
                "https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html"
              ),
            ]
          ),
        ]),
      ]),
      _c("div", [
        _c("strong", { staticClass: "sub-title" }, [
          _vm._v("阿里云文件上传服务(oss)"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(
            " 收集的数据：系统版本、mac地址、IP、MAC、App版本信息、设备型号、ip地址、网络信息、网络连接 "
          ),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v("个人信息类型：个人常用设备信息"),
        ]),
        _c("p", { staticClass: "left-line" }, [
          _vm._v(" 官网链接： "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html",
              },
            },
            [
              _vm._v(
                "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html"
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }